export default {
    dashboardsLoadSuccess: (state, payload) => {
        state.dashboards = payload;
        state.isLoadedDashboards = true;
    },
    dashboardsLoadFailure: (state, payload) => {
        state.dashboardsLoadFailure = payload;
    },
    userDashboardsLoadSuccess: (state, payload) => {
        state.userDashboards = payload;
        state.isLoadedUserDashboards = true;
    },
    userDashboardsLoadFailure: (state, payload) => {
        state.userDashboardsLoadFailure = payload;
    },
    gameTypesLoadSuccess: (state, payload) => {
        state.gameTypes = payload;
        state.isLoadedGameTypes = true;
    },
    gameTypesLoadFailure: (state, payload) => {
        state.gameTypesLoadFailure = payload;
    },
    userGameTypesLoadSuccess: (state, payload) => {
        state.userGameTypes = payload;
        state.isLoadedUserGameTypes = true;
    },
    userGameTypesLoadFailure: (state, payload) => {
        state.userGameTypesLoadFailure = payload;
    },
};
